import { version } from './version';

export const environment = {
  name: 'development',
  environmentName: 'Dev',
  enableEnvBanner: true,
  production: false,
  version,
  apiBaseUrl: 'https://dev-api.mymidland.com/api',
  wsUrl: 'wss://mid-mymidland-nonprod-sse-ws-dev.azurewebsites.net/api/SSE/SubscribeServerNotifications',
  applicationInsights: {
    enabled: true,
    connectionString: 'InstrumentationKey=491e5bf8-0abf-4ecb-83f3-c03efbbb95f4;IngestionEndpoint=https://canadacentral-0.in.applicationinsights.azure.com/'
  },
  cookieConsent: {
    enabled: true,
    domainScriptId: '01a0a164-819b-7344-b14e-e70831e57ecb',
    scriptUrl: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js'
  },
  quickLinks: {
      privacyPolicyEn: 'https://srpzvx.files.cmp.optimizely.com/download/assets/Privacy+Policy_EN.pdf/53de525698ec11ee89d86e3ec7b13aaa',
      privacyPolicyFr: 'https://srpzvx.files.cmp.optimizely.com/download/assets/Privacy+Policy_FR.pdf/a81cfb8898ec11ee972cce40c62ff5ad',
      termsAndConditionsEn: 'https://srpzvx.files.cmp.optimizely.com/download/assets/MID-Website+Terms+of+Use_EN-0126.pdf/292d8bfcf6ec11f0ba06c2cee872574a',
      termsAndConditionsFr: 'https://srpzvx.files.cmp.optimizely.com/download/assets/MID-Website+Terms+of+Use_FR-0126.pdf/656cbaacf6ec11f0ad1506a4f9ad633e',
      shipSSO: 'https://midb2ctenantpoc.ciamlogin.com/MidB2CTenantPoC.onmicrosoft.com/saml2?SAMLRequest=jZFNa4NAEIb%2fiuzdb23sooKJCQQSKLHtobdFp3HB3bU7a%2bjP70brqbT0Osy8PM87OTIxjLSaTC8v8DEBGudTDBILMmlJFUOOVDIBSE1Lm%2bp8opEXUAGGdcww4hzrghyypM6yrKribZLswm2WJPEmrZJ9FoVB%2fbgnzito5EoWxB7bG8QJjhINk8aOgih1g9gNHp7DmAYxjVIvTjdv970nhshvUJB3NiAQp0IEbWzSTkmcBOgG9I238HI5FaQ3ZkTq%2b4J3A5Oda%2fOvXF69CHs%2beq0S%2fp3f%2fy2DLOJ0buRv%2fVEro1o1EOegdAtzeytjmc96%2bj81shWFlCt81FhY9%2fyt0CwKub9klrn%2f81%2flFw%3d%3d'
  },
  externalLinks: {
    shipSso:
      'https://midb2ctenantpoc.ciamlogin.com/MidB2CTenantPoC.onmicrosoft.com/saml2?SAMLRequest=jZFNa4NAEIb%2fiuzdb23sooKJCQQSKLHtobdFp3HB3bU7a%2bjP70brqbT0Osy8PM87OTIxjLSaTC8v8DEBGudTDBILMmlJFUOOVDIBSE1Lm%2bp8opEXUAGGdcww4hzrghyypM6yrKribZLswm2WJPEmrZJ9FoVB%2fbgnzito5EoWxB7bG8QJjhINk8aOgih1g9gNHp7DmAYxjVIvTjdv970nhshvUJB3NiAQp0IEbWzSTkmcBOgG9I238HI5FaQ3ZkTq%2b4J3A5Oda%2fOvXF69CHs%2beq0S%2fp3f%2fy2DLOJ0buRv%2fVEro1o1EOegdAtzeytjmc96%2bj81shWFlCt81FhY9%2fyt0CwKub9klrn%2f81%2flFw%3d%3d'
  },
  auth: {
    enabled: true,
    clientId: 'e5774149-5793-4041-9c86-7409c81fb870',
    authority: 'https://midb2ctenantpoc.ciamlogin.com/483c55c8-c463-4546-8ccb-a4d0934bb05d',
    redirectUri: '/',
    postLogoutRedirectUri: '/',
    loginFailedRedirectUri: '/unauthorized',
    scopes: ['api://29dc7a63-5d74-4778-b7da-f7f8f3fa2f43/api.access', 'user.read', 'openid', 'profile'],
    protectedResources: [
      {
        uri: 'https://graph.microsoft.com/v1.0/me',
        scopes: ['user.read', 'profile']
      },
      {
        uri: 'https://graph.microsoft.com/v1.0/users/*',
        scopes: ['user.read', 'profile']
      },
      {
        uri: 'https://dev-api.mymidland.com/api/*',
        scopes: ['api://29dc7a63-5d74-4778-b7da-f7f8f3fa2f43/api.access', 'user.read']
      }
    ] as { uri: string; scopes: string[] }[]
  }
};
